import React, { Component } from 'react'
import { withSettings } from './withSettings'
import Form from './Form'

@withSettings
export default class PrivacySettings extends Component {

  state = {
    showConsent: this.props.getSettingsAt('privacy.require_signup_consent', false),
  }

  handleData = data => {
    if (this.state.showConsent) {
      return this.props.setSettingsAt('privacy', {
        require_signup_consent: true,
        business_name: data.business_name,
        ...data,
      })
    } else {
      return this.props.setSettingsAt('privacy', { require_signup_consent: false, business_name: data.business_name })
    }
  }

  handleShowConsent = event => {
    this.setState({ showConsent: event.target.checked })
  }

  renderUrlFields() {
    if (this.state.showConsent) {
      const defaults = this.props.getSettingsAt('privacy')
      return (
        <div>
          <div className="form-section">
            <label>Privacy Policy URL</label>
            <p className="muted">
              The FULL page URL of the Privacy Policy on your website.
            </p>
            <input name="privacy_policy_url" defaultValue={defaults.privacy_policy_url} />
          </div>

          <div className="form-section">
            <label>Cookie Policy URL</label>
            <p className="muted">
              The FULL page URL of the Cookie Policy on your website.
            </p>
            <input name="cookie_policy_url" defaultValue={defaults.cookie_policy_url} />
          </div>

          <div className="form-section">
            <label>Terms of Use URL</label>
            <p className="muted">
              The FULL page URL of the Terms of Use on your website.
            </p>
            <input name="terms_url" defaultValue={defaults.terms_url} />
          </div>

          <br /><br />
        </div>
      )
    }
  }

  render() {
    const defaults = this.props.getSettingsAt('privacy')

    return (
      <div className="container padded settings">
        <Form onData={this.handleData}>
          <div className="panel padded">
            <h2 className="title">Privacy Settings</h2>

            <div className="form-section">
              <label>Mobile Carrier Opt-in Consent</label>

              <p className="muted">
                In order to send SMS through a 3rd-party CRM to a lead, you are required to provide an opt-in checkbox associated with the following text:
              </p>

              <p style={{ margin: 20, marginLeft: 40 }} className="muted">
                {`"I agree to be contacted by {{business_name}} via call, email, and text for real estate services. To opt out, you can reply ‘stop’ at any time or reply ‘help’ for assistance. You can also click the unsubscribe link in the emails. Message and data rates may apply. Message frequency may vary. {{privacy_policy_url}}"`}
              </p>

              <p className='muted'>
                Please provide the Business Legal Name that is on your official documents. This will appear in the SMS opt-in compliance phrase:
              </p>

              <div>
                <input name='business_name' defaultValue={defaults.business_name} placeholder={this.props.websites.current.main_user_name} />
                <small><i>Character limit: 200</i></small>
              </div>
            </div>

            <div className="form-section">
              <label>Expressed Consent On Sign Up Form</label>
              <label style={{display: 'flex'}}>
                <input
                  style={{width: 'auto', marginRight: '15px', marginTop: '3px', boxShadow: 'none'}}
                  type="checkbox"
                  checked={this.state.showConsent}
                  onChange={this.handleShowConsent} />
                <p className="muted">
                  Display a data use consent on the sign up to ensure you have expressed to access and process the leads personal data. This consent displays in the form and conforms to GDPR data privacy regulations requirements for consent.
                </p>
              </label>
            </div>

            {this.renderUrlFields()}

            <div className="form-section">
              <label>Showcase IDX and Your Website’s Privacy Policies</label>
              <p className="muted">
              DISCLAIMER: please be aware that you may be required by applicable data privacy laws to gain consent 
              from and provide notice of your privacy practices to individuals from whom you collect personal 
              information using the Showcase IDX platform.  Showcase IDX, Inc. is not responsible for ensuring your 
              compliance with applicable data privacy laws, and we encourage you to seek counsel who can advise you 
              on your compliance obligations.
              </p>
            </div>

          </div>

          <button type="submit" className="big shadowed">Save Changes</button>
        </Form>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// client/components/sections/website/settings/Privacy.js